import Role_writing from '../../component/Services_Component/Role_writing';
import useMetaTags from '../../hooks/useMetaTags';
import { roleWriting, LargeData, AssistanceSection, FAQ } from '../../Data/All_Services_Data/erpSoftwareDevelopmentServicesData';
import Handle_Largedata_section from '../../component/Services_Component/Handle_Largedata_section';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';

const ErpSoftwareDevelopmentServices = () => {
    useMetaTags({
        title:
            "How Warrgyizmorsch Delivers Custom ERP Software Development Services",
        description:
            "Discover how Warrgyizmorsch provides custom ERP software development services designed to streamline operations, improve data flow, and support business scalability.",
        keywords:
            "Custom ERP Solutions, Custom ERP Software Development, Custom ERP Services, ERP Solutions, Enterprise Resource Planning Systems, Enterprise Resource Management, Enterprise Resource Management System, ERP Software, Custom ERP Software Development, Custom ERP Solutions, ERP, ERP System",
    });
    return (
        <>
            <section
                className=""
                style={{
                    backgroundImage: `url('assets/img/service/serviceD.jpg')`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                }}
                id="service-sec"
            >
                <div className="round-container pt-5">
                    <div className="container">
                        <div className="title-area text-center">
                            <span className="sub-title text-white">OUR SERVICES</span>
                            <h1 className="sec-title text-white">
                                Custom ERP Software Development Services
                            </h1>
                        </div>
                    </div>
                </div>
            </section>
            <section className="space-extra-bottom">
                <div className="page-single">
                    <div className="page-content">
                        <style>{`
                        .header-section{
                            display: flex;
                            align-items: center;
                            gap: 20px;
                            margin-bottom: 30px;
                        }
                        .header-section img{
                            height: 400px;
                        }
                        .header-section p{
                            text-align: left;
                        }

                        @media only screen and (max-width: 990px) {
                            .header-section{
                                flex-direction: column;
                            }
                            .header-section img{
                                height: 200px;
                            }
                            .header-section p{
                                text-align: center;
                            }
                        }
                        `}</style>
                        {/* Intro part  */}
                        <div
                            className="header-section container"
                            style={{ marginTop: "20px" }}
                        >
                            <img
                                src="assets/img/icon/erp-development.png"
                                loading="lazy"
                                alt="heading_image"
                            />
                            <div>
                                <p>
                                    Warrgyizmorsch gives Custom ERP Solutions development services, which match your business process with precision and flexibility. We understand every company has a unique way of working, so we create Custom ERP Services for scalability, efficiency, and total control in your operations. Our team has deep industry knowledge, using our hands-on experience to deliver solutions that are robust, easy for users, and ready for future needs. Startups and established enterprises both benefit from streamlined operations, better data visibility, and faster decision-making using our ERP. We design ERP solutions that expand as your business grows, bringing flexibility and high performance during every business stage.
                                </p>
                            </div>
                        </div>

                        <Role_writing data={roleWriting} />

                        <Handle_Largedata_section LargeData={LargeData} />

                        <section className="erp-section container">
                            <style>
                                {`
                                .erp-section {
                                    padding: 2.5rem 1rem;
                                    background-color: white;
                                    font-family: Arial, sans-serif;
                                    color: #1f2937;
                                }

                                .erp-section-heading {
                                    text-align: center;
                                }

                                .erp-section-body {
                                    display: flex;
                                    flex-direction: column;
                                    gap: 2rem;
                                }

                                .erp-section-image {
                                    text-align: center;
                                }

                                .erp-section-image img {
                                    max-width: 100%;
                                    height: auto;
                                }

                                .erp-section-lists {
                                    display: grid;
                                    grid-template-columns: 1fr;
                                    gap: 1rem;
                                }

                                .erp-section-lists ul {
                                    padding-left: 1.25rem;
                                    list-style: disc;
                                }

                                .erp-section-lists li {
                                    margin-bottom: 0.25rem;
                                }

                                @media (min-width: 768px) {
                                    .erp-section-body {
                                    flex-direction: row;
                                    align-items: center; /* Center image and lists vertically */
                                    }

                                    .erp-section-image {
                                    width: 33.333%;
                                    }

                                    .erp-section-lists-wrapper {
                                    width: 66.666%;
                                    }

                                    .erp-section-lists {
                                    grid-template-columns: 1fr 1fr;
                                    }
                                }
                                `}
                            </style>

                            <div className="erp-section-heading">
                                <h2>Features of Custom ERP Software</h2>
                                <p>
                                Our ERP software comes with features for inventory, finance, human resources, CRM, production, and more, and is tailored to your tasks. Instant data access, secure role-based access, customizable dashboards, and strong reporting let you make better business decisions. Support for multi-location operations, several languages, and mobile management help you control business in different cases. Automations cut down manual errors, making day-to-day tasks more efficient and data always reliable. Every ERP build is made for security and to follow compliance rules, making sure your data is always safe and operations stable.
                                </p>
                            </div>

                            <div className="erp-section-body">
                                <div className="erp-section-image">
                                <img src="/assets/img/icon/erp_service.jpeg" alt="ERP Features" />
                                </div>

                                <div className="erp-section-lists-wrapper">
                                <div className="erp-section-lists">
                                    <ul>
                                    <li>Customer Relationship Management</li>
                                    <li>Inventory Management</li>
                                    <li>Project Management</li>
                                    <li>Enterprise Asset Management</li>
                                    <li>Distribution Management</li>
                                    <li>Supply Chain Management</li>
                                    <li>Document Management</li>
                                    <li>Analytics &amp; Reporting</li>
                                    </ul>
                                    <ul>
                                    <li>Financial Management</li>
                                    <li>Service Management</li>
                                    <li>Material Resource Planning</li>
                                    <li>Lot &amp; Serial Traceability</li>
                                    <li>Field Service Management</li>
                                    <li>Warehouse Management</li>
                                    <li>Purchase Order Management</li>
                                    <li>GR Management</li>
                                    </ul>
                                </div>
                                </div>
                            </div>
                        </section>


                        <section className='container extra-space'>
                            <style>{`
                                .extra-space {
                                padding-top: 4rem;
                                }
                                .grid-container {
                                padding-top: 2rem;
                                display: grid;
                                grid-template-columns: repeat(3, 1fr);
                                grid-template-rows: repeat(3, auto);
                                gap: 1rem;
                                }
                                .grid-item {
                                //   background: #f9f9f9;
                                //   padding: 1rem;
                                //   border-radius: 0.75rem;
                                //   box-shadow: 0 2px 8px rgba(0,0,0,0.08);
                                display: flex;
                                flex-direction: column;
                                // justify-content: center;
                                align-items: center;
                                text-align: justify;
                                }
                                .grid-item img {
                                max-width: 100%;
                                height: auto;
                                border-radius: 0.75rem;
                                }
                                .grid-item h3 {
                                font-size: 1.1rem;
                                margin-bottom: 0.5rem;
                                }
                                .grid-item p {
                                font-size: 0.9rem;
                                line-height: 1.4;
                                color: #555;
                                }
                                @media (max-width: 768px) {
                                .grid-container {
                                    grid-template-columns: 1fr;
                                }
                                }
                            `}</style>

                            <div>
                                <h2>Custom ERP Services & Solutions from Warrgyizmorsch Expert Developers</h2>
                                <p>Warrgyizmorsch delivers full-scope ERP development using experienced specialist teams. From advice to launch and ongoing support, each step of ERP development comes under one roof with us. We believe ERP should not only be technically strong, but operationally useful for your company. Our team knows many technology stacks and frameworks, building systems to your specs, whether it’s a new system or a big upgrade. You get total customization, and all parts work together smoothly for your business processes. Focus stays on results, good system performance, and matching business goals, giving you an ERP solution that creates clear value.</p>
                            </div>
                            <div className="grid-container">
                                {/* Top-left */}
                                <div className="grid-item">
                                    <h3>Custom ERP Development</h3>
                                    <p>Our Custom ERP Software development is about solutions that mirror your business process and aim. Understanding your daily workflow is the first step, then we design architecture to match you. We build databases, interfaces, and all components to give control, scale, and durability. Each ERP is designed with speed, data integrity, and good user experience. Cloud or on-premise, every solution keeps uptime and safety a main target. Regular updates and support are always included to keep your technology ahead. With this approach, you get only what you need, nothing extra, in your ERP platform.</p>
                                </div>

                                {/* Top-center */}
                                <div className="grid-item">
                                    <h3>Expert ERP Implementation</h3>
                                    <p>We offer expert ERP implementation to get results without workflow disruption. The process starts with requirement study, then planning, configuration, and checking. We install every ERP module according to your business structure and process order. Staff receive training and support documents, letting them use ERP faster. Our focus is systems that are simple to use and bring instant benefits to your operation. Risk and data security are managed all through the implementation, while keeping to your schedule strictly. After setup, our team stays ready for support and further optimization. With us, you receive a transparent, step-by-step ERP implementation that really works.</p>
                                </div>

                                {/* Top-right */}
                                <div className="grid-item">
                                    <h3>Seamless Data Migrations</h3>
                                    <p>For companies moving from old to new ERP, we provide seamless data migration so important information stays protected. We handle mapping, checking, moving, and confirming every piece of data for safe and correct transfer. Historic data remains safe and ready to use in the new setup. Proven technical tools and scripts help avoid manual mistakes and reduce downtime. No matter if your company is changing ERP or upgrading, your operation will stay continuous through the move. Focus is on secure processes, keeping migration fast, and staying productive for your business the whole time.</p>
                                </div>

                                {/* Middle-left */}
                                <div className="grid-item">
                                    <h3>AI & ERP Integration Services</h3>
                                    <p>Our company delivers advanced AI and ERP integration services to boost enterprise system intelligence across every department. Machine learning models and predictive analytics get integrated directly into your ERP, so you can automate several business processes and make accurate forecasts for strategic actions. These integration solutions help optimize inventory management, increase customer engagement, and raise operational efficiency throughout business workflows. We design AI-powered modules to fit perfectly with your ERP infrastructure, which increases productivity, gives better predictions, and deeper business insight. If you want chatbot integration, AI-driven reporting, or a smarter supply chain, we ensure your ERP features stay up to date with technology trends. Let us transform your current ERP into a system that can learn business patterns and continue evolving as your company grows.</p>
                                </div>

                                {/* Middle-center (Image) */}
                                <div className="grid-item" style={{justifyContent:"center"}}>
                                    <img
                                        src="assets/img/icon/erp.png"
                                        alt="ERP Solutions"
                                    />
                                </div>

                                {/* Middle-right */}
                                <div className="grid-item">
                                    <h3>ERP System Configurations</h3>
                                    <p>We offer ERP system configuration services that match all software settings with your business logic and daily workflows. Every setting and permission is tailored to reflect specific operational priorities and approval flows your teams require. For user roles, automation rules, and approval hierarchies, we handle each configuration so your systems reach high usability and operational efficiency. User interfaces and dashboard layouts are also adapted for each team to create smooth accessibility and clear navigation. Testing and gathering feedback are part of our process, allowing us to fine-tune ERP setup until it matches team preferences exactly. You gain a fully aligned system that operates in the same rhythm as your business, customized to deliver maximum performance.</p>
                                </div>

                                {/* Bottom-left */}
                                <div className="grid-item">
                                    <h3>Data Warehousing</h3>
                                    <p>We provide businesses with strong data warehousing solutions, making it possible to centralize, manage, and analyze large amounts of data for their ERP. Our data warehouses are ready to store structured and unstructured inputs from many sources, supporting direct ERP system integration. Your data stays consistent, accessible, and quick to retrieve, with high performance standards maintained throughout. These warehousing solutions support compliance tasks, trend forecasting, and performance monitoring for strategic planning across teams. Our assistance makes your ERP more data-driven, greatly improving visibility and making business intelligence actionable.We also make sure that it is scalable so that your storage can expand as per your business requirements. Data updates in real time and strong backup systems ensure low downtime and continuity.</p>
                                </div>

                                {/* Bottom-center */}
                                <div className="grid-item">
                                    <h3>Powerful Reporting</h3>
                                    <p>From fast executive summaries to detailed analysis, our ERP reporting modules facilitate smart business decisions with precision and pace. Analytics and visualization tools are also built in for simple data interpretation and communication. With our solutions, every business translates their data into actionable knowledge for performance monitoring and ongoing development. Personalizable dashboards enable various departments to monitor what's most critical for them. Reports may be scheduled or created in real-time, providing timely insights. Drill-down features enable one to delve deeper from high-level aggregates to detailed data. Smooth integration with their current ERP systems minimizes disruption. Our reporting solutions facilitate KPI monitoring, compliance audits, and strategic reviews with accuracy and ease</p>
                                </div>

                                {/* Bottom-right */}
                                <div className="grid-item">
                                    <h3>Custom ERP Dashboards</h3>
                                    <p>We design custom ERP dashboards to give every user level a personalized, actionable view of key performance indicators. Every dashboard interface is responsive, easy to navigate, and organized for clear communication of business objectives. Complex data turns into easy visuals that help teams act quickly and maintain alignment with targets. Customers are able to create alerts and thresholds so that they are informed in real time. Role-based access enables sensitive information to only be seen by the appropriate people. Interactive charts, filters, and widgets enable users to dive deeply into the data without technical proficiency. Dashboards are device-fully compatible to facilitate working on-the-go. Our solutions guarantee that decision-makers receive the appropriate information at the appropriate time, each time.</p>
                                </div>
                            </div>
                        </section>

                        <Assistance_section data={AssistanceSection} />

                        {/* FAQ section  */}
                        <FAQ_section data={FAQ} />
                    </div>
                </div>
            </section>
            <div className="scroll-top">
                <svg
                    className="progress-circle svg-content"
                    width="100%"
                    height="100%"
                    viewBox="-1 -1 102 102"
                >
                    <path
                        d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
                        style={{
                            transition: "stroke-dashoffset 10ms linear 0s",
                            strokeDasharray: "307.919, 307.919",
                            strokeDashoffset: "307.919",
                        }}
                    ></path>
                </svg>
            </div>
        </>
    )
}

export default ErpSoftwareDevelopmentServices